import React from "react";
import ConciergeDetail from "../../Concierge/List/components/ConciergeDetail";

export default function ConciergeUserMyConcierge() {
  return <ConciergeDetail userMode />;
}

